import React, { Component } from 'react';
import { LogRow } from './Styles';

class Recruitment extends Component {
  render() {
    const { data, onSelect } = this.props;
    return (
      <LogRow onClick={() => onSelect(data, 'recruitment')}>
        { data.name }
      </LogRow>
    );
  }
}

export default Recruitment;